import { render, staticRenderFns } from "./Webchat.vue?vue&type=template&id=e12bd2ce"
import script from "./Webchat.vue?vue&type=script&lang=js"
export * from "./Webchat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports